import React, { Component } from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormFeedback,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  Alert,
} from 'reactstrap';
import PropTypes from 'prop-types';
import { compose, graphql } from 'react-apollo';
import { CreateUserMutation } from './graphql';

const CreateUserGQL = compose(graphql(CreateUserMutation, { name: 'create' }));

class ConfirmDialog extends Component {
  static propTypes = {
    onClick: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  static defaultProps = {
    open: true,
  };
  constructor(props) {
    super(props);
    this.state = {
      modal: this.props.open,
      input: {
        username: '',
        password: '',
        firstname: '',
        lastname: '',
        phone: '',
        email: '',
        status: '',
      },
      confirmpassword: '',
      errormsg: '',
    };
  }

  toggle = () => {
    this.setState({
      modal: !this.state.modal,
    });
    this.props.onClose();
  };

  handleInputChanged = e => {
    const data = this.state.input;
    data[e.target.name] = e.target.value;
    this.setState({
      input: data,
    });
  };
  handleConfirmPassword = e => {
    this.setState({
      confirmpassword: e.target.value,
    });
  };

  submitNewUser = async e => {
    e.preventDefault();
    if (!e.target.checkValidity()) {
      e.stopPropagation();
      e.target.classList.add('was-validated');
      return;
    }
    if (this.state.input.password !== this.state.confirmpassword) {
      this.setState({
        errormsg: 'The password do not match',
      });
      return;
    }
    try {
      const { status, ...rest } = this.state.input;
      rest.status = parseInt(status, 10);
      const newuser = await this.props.create({
        variables: {
          input: rest,
        },
      });
      this.toggle();
      this.props.onClick(newuser.data.createUser);
    } catch (error) {
      this.setState({
        errormsg: error.message,
      });
    }
  };
  render() {
    const { input } = this.state;
    return (
      <div>
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          backdrop="static"
          size="lg"
        >
          <ModalHeader toggle={this.toggle}>Add New User</ModalHeader>
          <ModalBody>
            {this.state.errormsg && (
              <Alert color="danger">{this.state.errormsg}</Alert>
            )}
            <Form noValidate onSubmit={e => this.submitNewUser(e)}>
              <Row>
                <Col xs="6">
                  <FormGroup>
                    <Label>Username</Label>
                    <Input
                      placeholder="Username"
                      required
                      name="username"
                      value={input.username}
                      onChange={e => this.handleInputChanged(e)}
                    />
                    <FormFeedback>The Username is required</FormFeedback>
                  </FormGroup>
                </Col>
                <Col xs="6">
                  <FormGroup>
                    <Label>Password</Label>
                    <Input
                      placeholder="Password"
                      type="password"
                      required
                      name="password"
                      value={input.password}
                      onChange={e => this.handleInputChanged(e)}
                    />
                    <FormFeedback>The Password is required</FormFeedback>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="6">
                  <FormGroup>
                    <Label>First name</Label>
                    <Input
                      placeholder="First Name"
                      name="firstname"
                      value={input.firstname}
                      onChange={e => this.handleInputChanged(e)}
                      required
                    />
                    <FormFeedback>The First Name is required</FormFeedback>
                  </FormGroup>
                </Col>
                <Col xs="6">
                  <FormGroup>
                    <Label>Confirm Password</Label>
                    <Input
                      placeholder="Confirm Password"
                      type="password"
                      required
                      name="confirmpassword"
                      value={this.state.confirmpassword}
                      onChange={e => this.handleConfirmPassword(e)}
                    />
                    <FormFeedback>
                      The Confirm Password is required
                    </FormFeedback>
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col xs="6">
                  <FormGroup>
                    <Label>Last Name</Label>
                    <Input
                      placeholder="Last Name"
                      required
                      name="lastname"
                      value={input.lastname}
                      onChange={e => this.handleInputChanged(e)}
                    />
                    <FormFeedback>The Last Name is required</FormFeedback>
                  </FormGroup>
                </Col>
                <Col xs="6">
                  <FormGroup>
                    <Label>Email</Label>
                    <Input
                      placeholder="Email Address"
                      required
                      name="email"
                      value={input.email}
                      onChange={e => this.handleInputChanged(e)}
                    />
                    <FormFeedback>The Email Address is required</FormFeedback>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="6">
                  <FormGroup>
                    <Label>Phone</Label>
                    <Input
                      placeholder="Phone Number"
                      required
                      name="phone"
                      value={input.phone}
                      onChange={e => this.handleInputChanged(e)}
                    />
                    <FormFeedback>The Phone Number is required</FormFeedback>
                  </FormGroup>
                </Col>
                <Col xs="6">
                  <FormGroup>
                    <Label>Status</Label>
                    <Input
                      type="select"
                      value={input.status}
                      onChange={e => this.handleInputChanged(e)}
                    >
                      <option value="0">Active</option>
                      <option value="1">InActive</option>
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
              <hr />
              <div>
                <Button color="success" type="submit">
                  Confirm
                </Button>{' '}
                <Button color="secondary" type="reset" onClick={this.toggle}>
                  Cancel
                </Button>
              </div>
            </Form>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default CreateUserGQL(ConfirmDialog);



// WEBPACK FOOTER //
// ./src/views/Users/AddNewUser.js